import { Card, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { skipToken } from '@reduxjs/toolkit/query';
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import { robotoRegular } from '@habitech/shared';
import {
  setSelectedStatus,
  getSelectedStatus,
  getSelectedProcess,
  getSelectedProcessStatus,
  getStartDate,
  getEndDate,
  getSelectedAlias,
} from '../../store/slices/domainOrchestratorPricingCommittee.slice';
import { useGetStatusCountsQuery } from '../../store/services/getOrchestratorStatusCounts';
import { ProcessStatusCountsInfo } from '../ProcessStatusCountsInfo';
import { useFilteredOrchestratorsCount } from '../../hooks/useFilteredOrchestratorsCount';

const statusLabels: Record<string, string> = {
  COMPLETED: 'Completados',
  IN_PROGRESS: 'En Progreso',
  REJECTED: 'Rechazados',
};

const statuses = ['COMPLETED', 'IN_PROGRESS', 'REJECTED'];

export const StatusCards = () => {
  const dispatch = useDispatch();
  const selected = useSelector(getSelectedStatus);
  const country = useSelector(getCountry);
  const selectedProcess = useSelector(getSelectedProcess);
  const selectedProcessStatus = useSelector(getSelectedProcessStatus);
  const startDate = useSelector(getStartDate);
  const endDate = useSelector(getEndDate);
  const workflowAlias = useSelector(getSelectedAlias);

  const { data: counts } = useGetStatusCountsQuery(
    country
      ? {
          country,
          start_date: startDate || undefined,
          end_date: endDate || undefined,
          workflow_alias: workflowAlias || undefined,
        }
      : skipToken
  );

  const filterActive = selectedProcess !== '' || selectedProcessStatus !== '';

  const { count: inProgressFiltered } =
    useFilteredOrchestratorsCount('IN_PROGRESS');
  const { count: rejectedFiltered } = useFilteredOrchestratorsCount('REJECTED');

  const getFilteredCount = (status: string) => {
    if (status === 'IN_PROGRESS') {
      return inProgressFiltered;
    }
    if (status === 'REJECTED') {
      return rejectedFiltered;
    }
    return 0;
  };

  return (
    <Row className="mb-3 g-3" style={{ flex: '0 0 auto' }}>
      {statuses.map(status => {
        const filteredCount = getFilteredCount(status);
        return (
          <Col md={4} key={status}>
            <Card
              data-testid={`status-${status}`}
              className={`${selected === status ? 'border-success' : ''}`}
              onClick={() => dispatch(setSelectedStatus(status))}
              style={{ cursor: 'pointer' }}
            >
              <Card.Body>
                <div style={{ fontFamily: robotoRegular }}>
                  {statusLabels[status]}
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex gap-1">
                    <h3 className="mb-0">{counts?.[status] ?? 0}</h3>
                    <div className="d-flex justify-content-between">
                      {(status === 'IN_PROGRESS' || status === 'REJECTED') && (
                        <ProcessStatusCountsInfo status={status} />
                      )}
                    </div>
                  </div>
                  <div>
                    {filterActive &&
                      (status === 'IN_PROGRESS' || status === 'REJECTED') && (
                        <span
                          data-testid={`filtered-count-${status}`}
                          className=" small text-muted"
                        >
                          {filteredCount} encontrados
                        </span>
                      )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};
